// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { QuickTableUtils } from '../QuickTableUtils';
import { SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '../../../misc/ThemeManager';
export class TrailingColumnRenderer {
    DrawCell(context, eventArgs) {
        var _a, _b;
        const cellRect = new Rectangle(eventArgs.x, eventArgs.y, eventArgs.width, eventArgs.height);
        context.FillRectWithRect(new SolidBrush(eventArgs.BackColor), cellRect);
        const xPadding = eventArgs.table.getXPadding(eventArgs.columnIndex, context.textAlign);
        const yPadding = eventArgs.table.getYPadding(cellRect.Height, QuickTableUtils.GetTextHeight(context));
        const textBrush = new SolidBrush(eventArgs.ForeColor);
        const isTrailingSL = (_b = (_a = eventArgs.row.item) === null || _a === void 0 ? void 0 : _a.isTrailingSL) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (isTrailingSL) {
            const icon = ThemeManager.NewImages.trailingIconDefault;
            const iconRect = eventArgs.table.getButtonRectangle(cellRect.X + xPadding * 0.5, cellRect.Y + yPadding * 0.5, icon.image.width, icon.image.height);
            context.DrawCenteredImage(icon.image, iconRect);
        }
        QuickTableUtils.DrawTextInRect(context, eventArgs.cell.formattedValue, eventArgs.font, textBrush, cellRect.X, cellRect.Y, cellRect.Width, cellRect.Height, xPadding, yPadding, true);
        eventArgs.handled = true;
    }
    ProcessMouseMove(eventArgs) {
        /* do nothing, we don't need to handle mouse move for this column */
    }
    ProcessMouseLeave(eventArgs) {
        /* do nothing, we don't need to handle mouse leave for this column */
    }
}
